import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import { Toolbar, Typography, IconButton, Hidden } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

const useStyles = makeStyles(theme => ({ 
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        height: 60,
    },
    divider: {
        flexGrow: 1,
    },
}));

export default function Banner(props) {
    const classes = useStyles();

    return (
        <AppBar className={classes.appBar} position='fixed'>            
            <Toolbar>
                <Typography variant='h5'>
                    Perfect Face
                </Typography>
                <div id='divider' className={classes.divider}/>
                <Hidden mdUp>
                    <IconButton edge='end' color="inherit" aria-label="open drawer"
                        onClick={_ => props.sidePanelToggle()}
                    >
                        <MenuIcon />
                    </IconButton>
                </Hidden>
                
            </Toolbar>
        </AppBar>
    )
}